var map = {
	"./BOT.jpg": 8386,
	"./TOP.jpg": 9354,
	"./content.txt": 8781,
	"./global.css": 8645,
	"./image1.jpg": 2390,
	"./image10.jpg": 1521,
	"./image11.jpg": 7839,
	"./image12.jpg": 3089,
	"./image13.jpg": 5011,
	"./image14.jpg": 726,
	"./image15.jpg": 7174,
	"./image16.jpg": 8193,
	"./image17.jpg": 6971,
	"./image18.jpg": 9763,
	"./image19.jpg": 1654,
	"./image2.jpg": 1374,
	"./image20.jpg": 8299,
	"./image21.jpg": 4863,
	"./image22.jpg": 2759,
	"./image23.jpg": 7901,
	"./image24.jpg": 5921,
	"./image25.jpg": 3659,
	"./image3.jpg": 5680,
	"./image4.png": 4447,
	"./image5.jpg": 5904,
	"./image6.jpg": 3262,
	"./image7.jpg": 7421,
	"./image8.jpg": 247,
	"./image9.jpg": 5430,
	"./logo.png": 6949,
	"./voice1.mp3": 8061,
	"./voice2.mp3": 900,
	"./voice3.mp3": 5451,
	"./voice4.mp3": 1575,
	"./voice5.m4a": 2258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;